var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLockicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 22,
    fill: "#1E1E1E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Add new vehicle detils from",
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2342,
    transform: "translate(-1007 -661)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003524"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1000002942"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 23949",
    x: -727.5,
    y: -15.5,
    width: 1121,
    height: 69,
    fill: "white",
    stroke: "#E8E8E8"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 1315",
    x: -727.5,
    y: -209.5,
    width: 1121,
    height: 533,
    rx: 9.6,
    stroke: "#E8E8E8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003233"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 34624273",
    filter: "url(#filter0_b_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -789,
    y: -662,
    width: 1242,
    height: 2342,
    fill: "black",
    fillOpacity: 0.26
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003526"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34624274",
    x: -475,
    y: -504,
    width: 575,
    height: 2028,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 1000003525"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vendor"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Frame 1000003392"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -414.5,
    y: -15.5,
    width: 454,
    height: 53,
    rx: 9.5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14 7.5H13V5.5C13 2.74 10.76 0.5 8 0.5C5.24 0.5 3 2.74 3 5.5V7.5H2C0.9 7.5 0 8.4 0 9.5V19.5C0 20.6 0.9 21.5 2 21.5H14C15.1 21.5 16 20.6 16 19.5V9.5C16 8.4 15.1 7.5 14 7.5ZM5 5.5C5 3.84 6.34 2.5 8 2.5C9.66 2.5 11 3.84 11 5.5V7.5H5V5.5ZM14 19.5H2V9.5H14V19.5ZM8 16.5C9.1 16.5 10 15.6 10 14.5C10 13.4 9.1 12.5 8 12.5C6.9 12.5 6 13.4 6 14.5C6 15.6 6.9 16.5 8 16.5Z",
    fill: "#969696"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -414.5,
    y: -15.5,
    width: 454,
    height: 53,
    rx: 9.5,
    stroke: "#E8E8E8"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_0_1",
    x: -793,
    y: -666,
    width: 1250,
    height: 2350,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_0_1",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 2342,
    fill: "white",
    transform: "translate(-1007 -661)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockicon);
export default __webpack_public_path__ + "static/media/lockicon.c25161dda62b62dd4433c0474d9b4559.svg";
export { ForwardRef as ReactComponent };